import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class ActivityIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20"><path fillRule="evenodd" d="M4 20l1-9H0L2 0h11L9 7h5z"/></svg>
        )
    }
}

export default withCssClassName(ActivityIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/activity-icon.js